<template>
  <div class="p-modal-wrap" @click="bgHide" v-if="isShow">
    <transition name="fade" appear>
      <template v-if="modalType">
        <div
          class="p-modal"
          :class="[modalType ? `p-modal--type${modalType}` : '']"
        >
          <slot></slot>
        </div>
      </template>
      <template v-else>
        <div class="p-modal" @click.stop>
          <slot></slot>
        </div>
      </template>
    </transition>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: {
    modalType: String,
    bgClickable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  methods: {
    show() {
      this.isShow = true;
    },
    hide() {
      this.isShow = false;
    },
    bgHide() {
      if (!this.bgClickable) return;
      this.hide();
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  margin-top: 30px;
}
</style>
